module.exports = __webpack_public_path__ + "static/media/icon_offline.0f18b288.png";